import React from 'react'
import './input-style.css'

const Input = (props) => {

  const { onChange, label, className, disabled, ...rest } = props;

  return (
    <div className={`ga-input-form-group ${className}`}>
      <input
        className={`ga-input-form-control ${disabled ? 'ga-input-is-disabled' : ''}`} 
        type={'text'}
        onChange={onChange}
        placeholder=" "
        disabled={disabled}
        id='input-form-1'
        {...rest}
      />
      <label htmlFor='input-form-1' className="ga-input-form-label">{label}</label>
    </div>
  )
}

export default Input
